import { isMSquaredHub } from "../../utils/isEnv";
import { getWorkspaceFromUrl } from "../utils/getWorkspaceFromUrl";

/**
 * Hook to get the path prefix for navigation
 * For M² Hub: returns /w/:workspace_subdomain
 * For normal environment: returns empty string
 */
export const useGetPathPrefix = (): string => {
  if (!isMSquaredHub()) {
    return "";
  }

  const workspaceSubdomain = getWorkspaceFromUrl();

  if (!workspaceSubdomain) {
    return "";
  }

  return `/w/${workspaceSubdomain}`;
};
